/** Centralized access to Vite public env vars. */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  wsUrl: import.meta.env.VITE_WS_URL ?? '/ws',
} as const;

/** Resolves the relative ws path (e.g. "/ws") to an absolute ws(s):// URL against the current origin. */
export function resolveWsUrl(path: string): string {
  if (/^wss?:\/\//i.test(path)) return path;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path.startsWith('/') ? path : `/${path}`}`;
}
